module.exports = {
  backToMain: 'Quay lại màn hình chính',
  print: 'In',
  savePDF: 'Lưu dưới dạng PDF',
  saveWord: 'Lưu dưới dạng WORD',
  saveExcel: 'Lưu dưới dạng EXCEL',
  email: 'Email',
  fax: 'Fax',
  company: 'Tên công ty',
  emailAddress: 'Địa chỉ email',
  cc: 'CC (Carbon Copy)',
  title: 'Tiêu đề email',
  content: 'Nội dung email',
  localAgent: 'Đại lý địa phương',
  destinationAgent: 'Đại lý cảng đi/đến',
  designationAgent: 'Đại lý hàng chỉ định',
  customer: 'Khách hàng',
  bookingAgent: 'Đại lý đặt chỗ',
  motorcade: 'Đội xe',
  warehouse: 'Kho hàng',
  send: 'Gửi',
  cancel: 'Hủy',
  tel: 'Điện thoại',
  ok: 'Xác nhận',
  faxCode: 'Mã vùng',
  faxNo: 'Số fax',
  faxExt: 'Số máy lẻ',
  BlAddress: 'Địa chỉ đối chiếu',
  ShippingCmp: 'Hãng tàu',
  NominatedAgent: 'Đại lý hàng chỉ định',
  PortAgency: 'Đại lý cảng đi/đến',
  InvokeLocalMailClient: 'Gọi hộp thư địa phương'
}
